import { createContext } from "react";



export interface TenantContextType {
    current: string | null;
    select: (id: string|null) => void;
   
}
export const TenantContext = createContext<TenantContextType | undefined>(undefined);